import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable()
export class MaintenanceGuard implements CanActivate {
	constructor(private router: Router, private maintenance: MaintenanceService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.maintenance.inMaintenance()) {
			this.router.navigate(['/maintenance']);
			return false;
		} else {
			return true;
		}
	}
}
